import type { LoaderFunctionArgs, MetaFunction } from "react-router";
import { SITE_NAME } from "@/lib/constants";
import FaviconPage from "@/pages/FaviconPage";

export async function loader({ params }: LoaderFunctionArgs) {
  const domain = params.domain!;
  return { domain };
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const domain = data?.domain ?? "";
  const origin = "https://loadlogo.com";

  const title = `${domain} Favicon | ${SITE_NAME}`;
  const description = `Favicon for ${domain}. Fetch website favicons via the ${SITE_NAME} API. Tries apple-touch-icon, high-res favicons, and Google fallback.`;

  return [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:image", content: `${origin}/og/favicon/${domain}` },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:url", content: `${origin}/favicon/${domain}` },
    { property: "og:site_name", content: SITE_NAME },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: `${origin}/og/favicon/${domain}` },
    { tagName: "link", rel: "canonical", href: `${origin}/favicon/${domain}` },
  ];
};

export default function FaviconRoute() {
  return <FaviconPage />;
}
